import {DateTime} from "luxon";
import type QueueHourDataData from "~~/api/response/data/queue/QueueHourDataData";

export default class QueueHourData {
  checkpointCode: string;
  date: DateTime;
  duration: number;
  throughput: number;

  constructor(data: QueueHourDataData) {
    this.checkpointCode = data.checkpoint_code;
    this.date = DateTime.fromISO(data.date);
    this.duration = data.duration;
    this.throughput = data.throughput;
  }
}
